export const Routes = {
  Login: 'login',
  Logout: 'logout',
  Callback: 'callback',
  SignoutCallback: 'signout-callback',
  SilentToken: 'silent-token',
}
